
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import AppEditContact from "@/components/contacts/ContactEdit.vue";
import AppSellCategorySelect from "@/components/SellCategorySelect.vue";
import {Contact, Sale} from "@/models/base";
import { SaleType } from "@/models/base";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppSaleTypeSelect from "./SaleTypeSelect.vue";
import { UserConfigService } from "@/services/user-config-service";
import AppCurrencySelect from "@/components/CurrencySelect.vue";
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import {BrowserInfo} from "@/utils/browser";
import {ScannerListener} from "@/utils/scanner";
import AppSaleEditVatRegimeSelect from "./SaleEditVatRegimeSelect.vue";

export default Vue.extend({
	data(){
		return {
			editContactModal: false
		};
	},
	props: {
		state: {
			required: true,
			type: Object as () => SaleEditState
		},
	},
	computed: {
		isMobile(): boolean {
			return BrowserInfo.isMobile();
		},
		autoFocus():Boolean{
			return UserConfigService.getSaleSettings().NewSaleAutoFocusField == "contact";
		},
		sale():Sale {
			return this.state.sale;
		},
		isSubscription():boolean {
			return this.sale.TypeID == 10;
		},
		saleTypeName():string {
			return this.sale.getTypeName(this.$i18n.locale);
		},
		ignoredTypes():number[]{
			return this.state.getIgnoredSaleTypes();
		},
		isAllowedMultiLanguages(){
			return AuthService.hasModule(15);
		},
		isAllowedMultiValuta(){
			return AuthService.hasModule(10);
		},
		groupId():number{
			return this.state.getContactGroupID();
		}
	},
	watch: {
		"sale.CurrencyID"(){
			this.state.productEditRowState.currency = this.sale.CurrencyID;
			this.state.productEditRowState.currencyRate = this.state.productEditRowState.getCurrencyRate;
			this.state.sale.CurrencyRate = this.state.productEditRowState.currencyRate;
		}
	},
	methods: {
		ScannerListener() {
			return ScannerListener;
		},
		async onContactSelect(contact: Contact) {
			await this.state.selectContact(contact);
			this.state.focusAfterContactSelect();
		},
		onTypeChange(newType: SaleType) {
			this.state.setSaleType(newType);
			this.state.setToPrintMessage(true);
		},
		async onVatChange(vatRegime:number){
			await this.state.onVatRegimeChange(vatRegime);

		},
		async save(){
			if (!this.sale.ContactID) {
				this.$wf.notify(this.$ct("error-contact-empty").toString(), "danger", 3500, "exclamation-triangle");
				return false;
			}
			if (this.sale.Rows.length <= 0) {
				this.$wf.notify(this.$ct("error-sale-empty").toString(), "danger", 3500, "exclamation-triangle");
				return false;
			}

			//Ticket? > save sale, open ticketrefund
			if(this.sale.showCashierRefundModal() && AuthService.hasModule(MODULE.WINKELMODULE)){
				try {
					await this.state.save();
					this.state.ticketRefundModalOpen = true;
				} catch (err) {
				}
			}else{
				this.state.openSaveModal();
			}

		},
		setLng(lng:string){
			this.state.setLng(lng);
		},
		async openEditContact(){
			let confirm = await this.$wf.confirm(
				this.$ct("confirm-edit-contact"),
				this.$t("common.yes"),
				this.$t("common.no"),
				this.$t("common.warning"),
				"warning"
			);
			if (!confirm) return;
			this.editContactModal = true;
		},
		clearContact() {
			this.sale.ContactID = 0;
			this.sale.CompanyName = "";
			this.sale.Contact = new Contact();
			this.sale.VatRegime = 1;
			this.sale.CurrencyID = 1;
			this.state.loyalty.balance = null;
		},
	},
	components: {
		AppContactSearch,
		AppSaleTypeSelect,
		AppSellCategorySelect,
		AppCustomLanguageSelect,
		AppEditContact,
		AppCurrencySelect,
		AppSaleEditVatRegimeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
